export const CHOICE_TYPE_MENU_BUTTON = 'choice-type-menu'
export const CHOICE_TYPE_MENU = 'customized-menu'
